export default class ReportConfigMetricType {
    public static Sequence = 0;
    public static Single = 1;
    public static OrganicSingle = 2;
    public static OrganicSum = 3;
}